const KEY = `bp:product-memory:v1:${window.Shopify?.theme?.id || 'store'}`;
const LIFETIME = 30 * 24 * 60 * 60 * 1000;
export const MEMORY_EVENT = 'bp:product-memory-change';
let currentProduct = '';
let readyPromise;
function notify() { document.dispatchEvent(new CustomEvent(MEMORY_EVENT)); }
function allowed() {
  try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
  catch { return false; }
}
function erase() { try { localStorage.removeItem(KEY); } catch {} }
function read() {
  const empty = { recent: [], favorites: [] };
  if (!allowed()) return empty;
  try {
    const raw = localStorage.getItem(KEY) || '{}';
    if (raw.length > 20000) return empty;
    const data = JSON.parse(raw), now = Date.now();
    for (const name of ['recent', 'favorites']) {
      const ids = new Set();
      empty[name] = (Array.isArray(data?.[name]) ? data[name] : []).filter((entry) => {
        if (!entry || typeof entry.id !== 'string' || !/^\d{1,20}$/.test(entry.id) || !Number.isFinite(entry.at)) return false;
        if (entry.at <= now - LIFETIME || entry.at > now || ids.has(entry.id)) return false;
        ids.add(entry.id);
        return true;
      }).slice(0, name === 'recent' ? 8 : 24);
    }
    return empty;
  } catch { return empty; }
}
function write(data) {
  if (!allowed()) return false;
  try { localStorage.setItem(KEY, JSON.stringify(data)); notify(); return true; }
  catch { return false; }
}
export function memoryReady() {
  if (readyPromise) return readyPromise;
  readyPromise = new Promise((resolve) => {
    if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') return resolve();
    if (!window.Shopify?.loadFeatures) return resolve();
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => resolve());
  }).then(() => { if (!allowed()) erase(); });
  return readyPromise;
}
document.addEventListener('visitorConsentCollected', async () => {
  await memoryReady();
  if (!allowed()) erase();
  else if (currentProduct) RecentlyViewed.addProduct(currentProduct);
  notify();
});
window.addEventListener('storage', (event) => { if (event.key === KEY || event.key === null) notify(); });
export class RecentlyViewed {
  static async addProduct(productId) {
    if (!/^\d{1,20}$/.test(productId)) return;
    currentProduct = String(productId);
    await memoryReady();
    const data = read();
    data.recent = [{ id: currentProduct, at: Date.now() }, ...data.recent.filter((entry) => entry.id !== currentProduct)].slice(0, 8);
    write(data);
  }
  static clearProducts() { const data = read(); data.recent = []; return write(data); }
  static getProducts() { return read().recent.map((entry) => entry.id); }
}
export class FavoriteProducts {
  static getProducts() { return read().favorites.map((entry) => entry.id); }
  static allowed() { return allowed(); }
  static toggle(productId) {
    if (!allowed()) return 'blocked';
    if (!/^\d{1,20}$/.test(productId)) return 'unavailable';
    const data = read(), existed = data.favorites.some((entry) => entry.id === productId);
    if (!existed && data.favorites.length >= 24) return 'full';
    data.favorites = data.favorites.filter((entry) => entry.id !== productId);
    if (!existed) data.favorites.unshift({ id: productId, at: Date.now() });
    if (!write(data)) return 'unavailable';
    return existed ? 'removed' : 'added';
  }
  static clearProducts() { const data = read(); data.favorites = []; return write(data); }
}
